<template>
  <div>
    <div class="header">
      <div class="menu">
        <a href="#" @click="showScan">Scan</a>
        <a href="#" @click="showLog">Log</a>
      </div>
    </div>
    <div>
      <label style="color: red">{{errorText}}</label>
    </div>
    <div id="scan" class="input-container">
      <input type="text" v-model="awb" placeholder="Scan AWB" @keydown="handleKeydown" >
    </div>
    <div>
      <label style="color: green">{{sucessText}}</label>
    </div>
    <div id="log">
      <b-table striped hover :items="log"></b-table>
    </div>
  </div>
  
</template>

<script>
  import { ACTIONS, CORE_PREFIX } from '../store/constants';
  import {yoyoHttp} from "@/services/http.service";

  export default {
      name: 'Scan',
      components: {},
      data(){
        return {
          awb: '',
          errorText: '',
          sucessText: '',
          log: []
        }
      },
      mounted() {
          this.$store.dispatch(CORE_PREFIX + ACTIONS.CORE.SET_LOADING, false);
          let menu = document.getElementById('navbar');
          menu.style.display = 'none';
          document.getElementById("log").style.display = "none";
      },
      methods: {
          ping() {
              let token = this.$AuthService.acquireTokenSilent();
          },
          async handleKeydown(event){
            // Check if the key pressed is the Tab key
            if (event.key === 'Tab' || event.key === 'Enter') {
              await this.scan(event); // Call your scan method
              // Optionally, prevent the default tab behavior
              event.preventDefault();
            }
          },
          async scan(event) {
            event.preventDefault();
            let resp = await yoyoHttp.post("api/Shipment/Scan",{ barcode: this.awb},'Failed to send data')
            if (resp.data !== "Success"){
              this.errorText = resp.data;
              let self = this;
              setTimeout(()=>{
                self.errorText = ''
              }, 3000)
            } else {
              this.sucessText = resp.data;
              let self = this;
              setTimeout(()=>{
                self.sucessText = ''
              }, 1000)
            }
            if (this.awb !== '') {
              this.log.push({scanTime: new Date(), scanned: this.awb, error: resp.data})
            }
            this.awb = ''
            
          },
          showLog(event) {
            event.preventDefault();
            document.getElementById("log").style.display = "";
            document.getElementById("scan").style.display = "none";
          },
          showScan(event) {
            event.preventDefault();
            document.getElementById("scan").style.display = "";
            document.getElementById("log").style.display = "none";
          }
      },
      computed: {
          user: function () {
              return this.$AuthService.getUser();
          },
      },
  };
</script>
<style scoped>
body {
  margin: 0;
  font-family: Arial, sans-serif;
}

a {
  color: white !important;
}

/* Container for the header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #3D4763;
  padding: 10px 20px;
  color: white;
  position: fixed; /* Fixes the menu at the top */
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000; /* Ensures it stays on top of other elements */
}

/* Logo style */
.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 50px; /* Adjust the logo size */
  width: auto;
}

/* Menu style */
.menu {
  display: flex;
}

.menu a {
  color: white;
  text-decoration: none;
  padding: 10px 20px;
  margin: 0 10px;
  transition: background-color 0.3s;
}

.menu a:hover {
  background-color: #575757;
}

/* Container for input field */
.input-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

input[type="text"] {
  padding: 10px;
  font-size: 16px;
  width: 300px;
}
</style>